import { render, staticRenderFns } from "./AdminMethods.vue?vue&type=template&id=1488d721&scoped=true"
import script from "./AdminMethods.vue?vue&type=script&lang=js"
export * from "./AdminMethods.vue?vue&type=script&lang=js"
import style0 from "./AdminMethods.vue?vue&type=style&index=0&id=1488d721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488d721",
  null
  
)

export default component.exports